import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TotalizarCampoPipe } from './totalizar-campo/totalizar-campo.pipe';



@NgModule({
  declarations: [
    TotalizarCampoPipe,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    TotalizarCampoPipe
  ]
})
export class UtilPipeModule { }
